// src/routes/ContactPage.js
import React from "react";
import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

const ContactPage = () => (
  <div>
    <Navbar />
    <PageHero
      label="Contact"
      heading="Let's talk."
      sub="Available for freelance projects and full-time opportunities."
    />
    <ContactForm />
    <Footer />
  </div>
);

export default ContactPage;
